<template>
  <!--    <div class="small" style="margin-left: -60px; margin-top: 40px; margin-bottom: -40px;">-->
  <div
    class="small"
    style="display: flex; align-items: center; justify-content: center"
  >
    <DoughnutChart
      :height="270"
      :chart-data="chartData"
      :options="chartOptions"
    />
  </div>
</template>

<script>
import DoughnutChart from './DoughnutChart'
import constants from '@/util/constants'
export default {
  name: 'AssetsChart',
  components: { DoughnutChart },
  data () {
    return {
      chartData: {
        labels: [],
        datasets: [
          {
            backgroundColor: [
              '#e6194b',
              '#3cb44b',
              '#ffe119',
              '#4363d8',
              '#f58231',
              '#911eb4',
              '#46f0f0',
              '#f032e6',
              '#bcf60c',
              '#fabebe',
              '#008080',
              '#e6beff',
              '#9a6324',
              '#fffac8',
              '#800000',
              '#aaffc3',
              '#808000',
              '#ffd8b1',
              '#000075',
              '#808080',
              '#ffffff',
              '#000000'
            ],
            borderWidth: 3,
            borderColor: this.$store.getters.isThemeLight
              ? '#ffffff'
              : '#2A2F44',
            data: []
          }
        ]
      },
      chartOptions: {
        animation: false,
        responsive: false,
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        cutoutPercentage: 60
      }
    }
  },
  watch: {
    assetsData: function () {
      this.updateChartData()
    }
  },
  created () {
    this.updateChartData()
  },
  computed: {
    assetsData () {
      if (this.$store.state.assets.allexchs) {
        return this.$store.state.assets.allexchsdata
      } else {
        return this.$store.state.assets.data
      }
    }
  },
  methods: {
    updateChartData () {
      // console.log('assets updated')
      const labels = []
      const dat = []
      const bgColor = []
      let otherNum = 0
      const localData = []
      if (this.assetsData) {
        this.assetsData.forEach((item) => {
          localData.push(item)
        })
      }
      localData.sort((a, b) => {
        return parseFloat(a.Value.U) > parseFloat(b.Value.U) ? -1 : 1
      })
      localData.forEach(function (elem) {
        // console.log("label:" + elem.Coin)
        if (parseFloat(elem.Share) > 1.0) {
          labels.push(elem.Coin)
          dat.push(elem.Value.U)
          const clr = constants.coinColors[elem.Coin]
          if (clr) {
            bgColor.push(clr)
          } else {
            bgColor.push(constants.coinOtherColors[otherNum])
            otherNum++
          }
        }
      })
      this.chartData.datasets[0].data = dat
      this.chartData.datasets[0].backgroundColor = bgColor
      this.chartData.labels = labels
      // this.data2 = []
      // localAssets.forEach(function (elem) {
      //   ref.data2.push(parseInt(elem.ValueUSD))
      // })
    }
  }
}
</script>

<style scoped>
.small {
  height: 300px;
  /*max-width: 600px;*/
  /*max-height: 500px;*/
  /*margin:  10px auto;*/
}
</style>
